export const ByteConvertUtils = {
  mbToBytes: (mb: number) => mb * 1e6,
};
